<template>
  <div class="h-datagrid">
    <h-form
      ref="formCreate"
      :model="formItem2"
      errorFocus
      cols="4"
      label-position="top"
    >
      <h-form-item
        :label="item.contract_ext_attr_name+'：'"
        :title="item.contract_ext_attr_name"
        v-for="(item, i) in itemList"
        :prop="item.contract_ext_attr_no"
        :required="item.need_required == 1"
        :key="`specialAttr${i}`"
      >
        <h-input
          v-if="item.input_box_type == 1"
          type="text"
          :maxlength="1000"
          v-model="formItem2[item.contract_ext_attr_no]"
          :placeholder="item.input_placeholder"
        ></h-input>
        <h-date-picker
          type="date"
          format="yyyy-MM-dd"
          v-if="item.input_box_type == 4"
          :no="item.contract_ext_attr_no"
          v-model="formItem2[item.contract_ext_attr_no]"
          showFormat
          :placeholder="item.input_placeholder"
        ></h-date-picker>
        <h-select
          v-if="item.input_box_type == 2"
          v-model="formItem2[item.contract_ext_attr_no]"
          :placeholder="item.input_placeholder"
        >
          <h-option
            v-for="item1 in item.contentList"
            :value="item1"
            :key="item1"
          ></h-option>
        </h-select>
        <h-select
          multiple
          v-if="item.input_box_type == 3"
          v-model="formItem2[item.contract_ext_attr_no]"
          :placeholder="item.input_placeholder"
        >
          <h-option
            v-for="(item2, i) in item.options"
            :value="item2.label"
            :key="item2.value"
          ></h-option>
        </h-select>

        <h-upload v-if="item.input_box_type == 6" :ref="`upload${item.contract_ext_attr_no}`" action="/light-plus/upload" :max-size="1024*50" name="files" :data="{
              business_type:9
            }" :on-exceeded-size="handleMaxSize" 
            :on-format-error="handleFormatError" 
            :before-upload="function (file) { return handleBeforeUpload(file, item.contract_ext_attr_no)}" 
            :on-success="function (response,file) { return uploadSuccess(response, file, item.contract_ext_attr_no,i)}" 
            :on-remove="function (response,file) { return moveSuccess(item.contract_ext_attr_no)}"
            with-credentials>
          <h-button type="ghost" icon="upload" >上传文件</h-button>
          
        </h-upload>
        <span v-if="item.input_box_type == 6" class="upload-tip">{{item.input_placeholder}}</span>

      </h-form-item>
    </h-form>
  </div>
</template>
<script>
import fetch from "@/api/httpFetch.js";
import Emitter from "@/utils/emitter";
import { deepClone } from '../../../utils';
export default {
  name: "createForm",
  data() {
    return {
      formItem2:{},
    };
  },
  props: {
    itemList: {
      type: Array,
      default() {
        return [];
      }, //用于接受父组件传递的值
    },
    formItem: {},
  },
  watch: {

     formItem: {
        handler(newName, oldName) {
          this.formItem2 = deepClone(newName);
        },
        immediate: true
      }
  },
  created() {
    console.log(this.formItem);
  },
  mounted() {
    this.formItem2 = deepClone(this.formItem);
  },
  methods: {
    handleFormatError(file) {
      this.$hNotice.warning({
        title: "文件格式不正确",
        desc: "文件 " + file.name + " 格式不正确。",
      });
    },
    handleMaxSize(file) {
      this.$hNotice.warning({
        title: "超出文件大小限制",
        desc: "文件 " + file.name + " 太大，不能超过 5M。",
      });
    },
    handleBeforeUpload: function (fil, no) {
      //    console.log(fil,index)
      this.$refs["upload" + no][0].fileList = [];
    },
    uploadSuccess: function (res, file, contract_ext_attr_no) {
      try {
        if (res.data.error_code == "0") {
          let download_files = {
            download_file_name:res.data.data[0].file_name,
            download_file_path:res.data.data[0].file_url
          }
          this.formItem2[contract_ext_attr_no] = JSON.stringify(download_files);
        } else {
          this.$hMessage.error(res.data.error_info);
          this.$refs["upload" + contract_ext_attr_no][0].fileList = []
          this.formItem2[contract_ext_attr_no] = ""
        }
      } catch (e) {
        this.$hMessage.error("上传失败");
      }
    },
    moveSuccess:function(contract_ext_attr_no){
      this.formItem2[contract_ext_attr_no] = "";
    },
  },
};
</script>
<style  lang="scss" scoped>
.upload-tip {
  position: absolute;
  top: 0;
  left: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 100px);
}
.h-form .h-form-item-label{
  text-align:left;
}
</style>


// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/createForm.vue